/* assets/header-brand.js */

/* ========= ユーティリティ ========= */
// 全角スペース変換・前後トリム・連続スペースの半角1文字化
function normalizeSpaces(q) {
  return q.replace(/\u3000/g, ' ').trim().replace(/\s+/g, ' ');
}

// 各単語を「タイトル・タグ・ハンドル」のみに限定（bodyを除外）するクエリ構築
function buildTargetedQuery(q) {
  // すでにコロン等のフィールド指定がある場合はユーザー入力を優先
  if (q.includes(':') || q.startsWith('*')) return q;

  const terms = q.split(' ').filter(Boolean);
  const clauses = terms.map(function(term){
    // カッコなどの特殊文字をサニタイズ
    const cleanTerm = term.replace(/[\(\)]/g, '');
    // title, tag, handle のみに検索範囲を絞り込む（bodyを除外）
    return '(title:' + cleanTerm + ' OR tag:' + cleanTerm + ' OR handle:' + cleanTerm + ')';
  });

  // 複数単語の場合はスペースで連結（Shopify標準のAND判定に任せる）
  return clauses.join(' ');
}

function looksExpanded(val){
  return /\(title:/.test(val) || /(?:\btitle:|\bhandle:|\btag:)/.test(val);
}

function tokensFromExpanded(q){
  if (!q) return [];
  const re = /\(title:([^ OR\)]+)/g;
  let m, out = [];
  while((m = re.exec(q)) !== null){ out.push(m[1]); }
  return out;
}

function restorePopupDisplay(){
  const inp = document.getElementById('search_input_popup');
  if (!inp) return;
  const v = inp.value || '';
  if (!looksExpanded(v)) return;

  // 送信時に保存した生の語を優先
  let raw = null;
  try { raw = sessionStorage.getItem('popup_last_raw_q') || null; } catch(_){}

  // ない場合はURLの q から復元（/search から戻った直後など）
  if (!raw) {
    try {
      const urlQ = new URLSearchParams(location.search).get('q') || '';
      const toks = tokensFromExpanded(urlQ);
      if (toks.length) raw = toks.join(' ');
    } catch(_){}
  }
  if (!raw) return;

  inp.value = raw;
  inp.setAttribute('value', raw); // 再描画対策
  try { inp.dispatchEvent(new Event('input', { bubbles: true })); } catch(_){}
}

/* ========= DOM 準備できたら実行 ========= */
document.addEventListener('DOMContentLoaded', function () {
  /* ===== ハンバーガー & サブメニュー ===== */
  (function () {
    const $nav      = $('nav');
    const $subTitle = $('.submenu-title');       // 無ければ空のままでもOK
    const $subWrap  = $('.panel-sub .subwrap');  // L1（サブ）
    const $subWrap2 = $('.panel-sub .subwrap2'); // L2（サブのサブ）
    const $subWrap3 = $('.panel-sub .subwrap3');

    // ハンバーガー
    $('#nav_toggle').on('click', function (e) {
      e.preventDefault();
      $('header').toggleClass('open');
      $('.container,.head_menu_blur').toggleClass('add_container');
      $nav.toggleClass('add_nav');
      
      // 初期化
      $nav.removeClass('view-sub view-sub2 view-sub3');
      $subWrap.empty();
      $subWrap2.empty();
      $subWrap3.empty();
      $subTitle.text('');
    

      // openクラスがあるかどうかでz-index切り替え
      if ($('header').hasClass('open')) {
        $('html, body').addClass('no-scroll'); 
        $('.header-banner').css('z-index', '0');
        $('.header-banner').css('display', 'none');
        $('.mobile-only').css('z-index', '0');
        $('.mobile-only').css('z-index', '0');
      } else {
        $('html, body').removeClass('no-scroll');
        $('.header-banner').css('z-index', '');
        $('.header-banner').css('display', 'block');
        $('.mobile-only').css('z-index', '');
      }
    });

    // ルート → サブ
    $nav.on('click', '.root-menu li.has-sub > a', function (e) {
      e.preventDefault();
      const $li   = $(this).closest('li.has-sub');
      const title = $(this).text().trim();
      const $tmpl = $li.children('.submenu-template').first().clone(true, true);
      $subTitle.text(title);
      $subWrap.html($tmpl.html()); // li群のみコピー
      $nav.addClass('view-sub');   // 左: root -100% / 右: sub 0%
      // L2初期化
      $nav.removeClass('view-sub2');
      $subWrap2.empty();
    });

    // サブ（L1） → サブのサブ（L2）
    $nav.on('click', '.panel-sub .subwrap li.has-sub2 > a', function (e) {
      e.preventDefault();
      e.stopImmediatePropagation();
      const $li    = $(this).closest('li.has-sub2');
      const label  = $(this).text().trim();
      const $tmpl2 = $li.children('.submenu-2-template').first().clone(true, true);
      $subWrap2.html($tmpl2.html());
      if ($subTitle.length) $subTitle.text(label);
      $nav.addClass('view-sub2');  // L1:-100% / L2:0%
      $nav.removeClass('view-sub3');
      $subWrap3.empty();
    });

    // ★ L2（2列） → L3（さらにスライド）
    $nav.on('click', '.panel-sub .subwrap2 li.has-sub3 > a', function (e) {
      e.preventDefault();
      e.stopImmediatePropagation();
      const $li    = $(this).closest('li.has-sub3');
      const label  = $(this).text().trim();
      const $tmpl3 = $li.children('.submenu-3-template').first().clone(true, true);
      $subWrap3.html($tmpl3.html());
      if ($subTitle.length) $subTitle.text(label);
      $nav.addClass('view-sub3');   // L1:-200% / L2:-100% / L3:0%
    });

    // 戻るボタン
    $nav.on('click', '.submenu-back', function () {
      if ($nav.hasClass('view-sub3')) {
        // L3 → L2
        $nav.removeClass('view-sub3');
        setTimeout(() => { $subWrap3.empty(); }, 350);
        return;
      }      
      if ($nav.hasClass('view-sub2')) {
        // L2 → L1
        $nav.removeClass('view-sub2');
        setTimeout(() => { $subWrap2.empty(); }, 350);
        return;
      }
      if ($nav.hasClass('view-sub')) {
        // L1 → ルート
        $nav.removeClass('view-sub');
        setTimeout(() => { $subWrap.empty(); }, 350);
        $subTitle.text('');
        return;
      }
      // ルートなら全閉
      $('header').removeClass('open');
      $('.container,.head_menu_blur').removeClass('add_container');
      $nav.removeClass('add_nav');
      $('html, body').removeClass('no-scroll');
    });

    // どの階層でも最終リンククリックでメニュー全閉
    $nav.on(
      'click',
      // L1：さらに子を持たない項目だけ閉じる
      '.panel-sub .subwrap li:not(.has-sub2) > a, ' +
      // L2：has-sub3 を持たない項目だけ閉じる
      '.panel-sub .subwrap2 li:not(.has-sub3) > a, ' +
      // L3：全部最終リンク扱いで閉じる
      '.panel-sub .subwrap3 a, ' +
      // ルートもサブを持たないものだけ
      '.root-menu li:not(.has-sub) > a',
      function () {
        $('header').removeClass('open');
        $('.container,.head_menu_blur').removeClass('add_container');
        $nav.removeClass('add_nav view-sub view-sub2');
        $subWrap.empty();
        $subWrap2.empty();
        $subTitle.text('');
        $('html, body').removeClass('no-scroll');
      }
    );
  })();

  /* ===== 検索ポップアップ ===== */
  (function(){
    const $pop = $('#search_popup');

    // 開く
    $('#search_btn').on('click', function(e){
      e.preventDefault();
      $pop.addClass('show').attr('aria-hidden', 'false');
      $('html, body').addClass('no-scroll');
      setTimeout(() => { $('#search_input_popup').trigger('focus'); }, 80);
    });

    // 閉じる共通関数
    function closeSearch(){
      $pop.removeClass('show').attr('aria-hidden', 'true');
      $('html, body').removeClass('no-scroll');
    }

    // ×ボタン / 背景クリック / Esc
    $('#search_clear').on('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();

      const popupInput = document.getElementById('search_input_popup');
      if (popupInput) {
        popupInput.value = '';
        try { popupInput.dispatchEvent(new Event('input', { bubbles: true })); } catch (_) {}
        popupInput.focus();
        try { sessionStorage.removeItem('popup_last_raw_q'); } catch (_){}
      }
    });

    // 背景クリックで閉じる（フォーム内は閉じない）
    $('#search_popup').on('click', function(e){
        if ($(e.target).closest('.search-shell').length === 0) {
          closeSearch();
        }
    });
    $(document).on('keydown', function(e){ if(e.key === 'Escape') closeSearch(); });

    // フォーム内クリックは閉じない
    $('#search_form_popup').on('click', function(e){ e.stopPropagation(); });
    
    // 閉じるボタン
    $('#search_close_popup').on('click', function(e){
      e.preventDefault();
      e.stopPropagation();
      closeSearch();
    });
    
    // 送信時：クエリ構築（body除外） + メタフィールドフィルタ投入
    const popupForm   = document.getElementById('search_form_popup');
    const popupInput = document.getElementById('search_input_popup');

    if (popupForm && popupInput) {
      popupForm.addEventListener('submit', function (e) {
        let q = popupInput.value || '';
        // 全角スペース→半角、前後trim、連続スペース1つ
        q = normalizeSpaces(q);
        if (!q) { e.preventDefault(); return; }

        try { sessionStorage.setItem('popup_last_raw_q', q); } catch(_){}

        // 商品説明文（body）を除外し、title / tag / handle に限定した構文に置換
        popupInput.value = buildTargetedQuery(q);

        // チェックでメタフィールドフィルタを付与
        // name="filter.p.m.custom._main-brand" に値を入れる
        const onlyBrand   = document.getElementById('only_brand');
        const brandHidden = document.getElementById('search_brand_popup');
        const filterBrand = document.getElementById('filter_brand');

        if (onlyBrand && brandHidden) {
          const val = (filterBrand && filterBrand.value) ? filterBrand.value : '';
          brandHidden.value = onlyBrand.checked ? val : '';
        }
      });
    }

    // 表示だけ「ユーザーの入力」に戻す（/search から戻った時など）
    restorePopupDisplay();
    window.addEventListener('pageshow', restorePopupDisplay);
  })();
});